// JadeTrade Brand Colors
// Primary jade green (#00A86B) is the authentic jade gemstone color
export const colors = {
  primary: '#00A86B',       // Jade Green - main brand color
  primaryDark: '#00875A',   // Darker jade for depth
  primaryLight: '#E6F5EF',  // Light jade for backgrounds
  primaryAccent: '#00D488', // Bright jade for highlights/dark mode
  background: '#F9FAFB',
  backgroundLight: '#F3F4F6',
  text: '#1F2937',
  textLight: '#6B7280',
  border: '#E5E7EB',
  error: '#F43F5E',
  errorLight: '#FFE4E6',
  success: '#00A86B',       // Using jade green for success too
  successLight: '#E6F5EF',
  white: '#FFFFFF',
  black: '#000000',
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const typography = {
  title: {
    fontSize: 32,
    fontWeight: '700' as const,
  },
  subtitle: {
    fontSize: 18,
    fontWeight: '500' as const,
  },
  body: {
    fontSize: 16,
  },
  caption: {
    fontSize: 14,
  },
}; 